export enum CustomerColumnKey {
  CustomerFirstName = 'firstName',
  CustomerLastName = 'lastName',
  CustomerEmail = 'email',
  CustomerPhone = 'phoneNumber',
  LoyaltyId = 'loyaltyId',
  Status = 'isActive',
  Actions = 'actions',
}
